exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.permission-group-name {\n    background-color: #333333;\n    color: #eeeeee;\n    border: 1px solid #333333;\n}\n.permission-description {\n    min-width: 300px;\n}\n", ""]);

// exports
